export const isBingoFtueTutorialFlagOn = (bingoFtueTutorialFF: boolean | 'off' | 'enabled') => {
  return [true, 'enabled'].includes(bingoFtueTutorialFF);
};

export const shouldShowBingoFtue = (
  isFlagEnabled: boolean,
  isAfterFirstSession: boolean,
  isInsideBingoArea: boolean,
): boolean => {
  if (!isFlagEnabled) {
    return false;
  }

  return isAfterFirstSession || isInsideBingoArea;
};
